export var checkWindow = function() {
    return "object" !== "undefined";
};
